<template>
    <div class="contentBox">
        <div class="goodsTop">
            <div class="searchTop">
                <div class="searchItem">
                    <el-cascader
                        clearable
                        v-model="platformTypeCode"
                        :props="props"
                        :options="platformTypeOptions"></el-cascader>
                </div>
                <div class="searchItem">
                    <el-input
                        v-model="goodsName"
                        placeholder="请输入商品名称">
                    </el-input>
                </div>
                <div class="searchItem">
                    <el-button class="searchBtn" @click="search">搜索</el-button>
                    <el-button type="text" class="resetBtn" @click="reset">
                        <i class="iconfont icon-qingchushujuku"></i>
                        <span>清除条件</span>
                    </el-button>
                </div>
            </div>
        </div>
        <div class="goodsListTable">
            <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%" class="tableContent">
                <el-table-column
                    prop="name"
                    label="商品名称"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="fullCategoryName"
                    label="商品分类"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="storeName"
                    label="服务商名称"
                    header-align="center"
                    show-overflow-tooltip
                    align="center">
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    header-align="center"
                    show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.createTime}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="statusCn"
                    label="状态"
                    header-align="center"
                    show-overflow-tooltip
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="open(scope.row.uuid,'STOCK')">下架</el-button>
                        <el-button type="text" size="small" @click="editSeoInfo(scope.row.uuid)">编辑SEO信息</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total" class="pagination">
            </el-pagination>
            <!-- 批量设置预警数量弹框 -->
            <el-dialog title="编辑SEO信息" :visible.sync="dialogVisible" class="regoods" width="700px">
                <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="SEO关键词" prop="seoKeyword">
                        <el-input type="textarea"
                                  v-model="editForm.seoKeyword"
                                  :rows="2"
                                  maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="SEO描述" prop="seoDescription">
                        <el-input type="textarea"
                                  :rows="3"
                                  v-model="editForm.seoDescription"
                                  maxlength="70" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button type="primary" @click="submitForm">提交</el-button>
                        <el-button @click="dialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {
        getGoodsAuditList,
        updateGoodsSeoInfo,
        updateGoodsInfoStatus,
        typetree,
        getGoodsInfo,
    } from '../../../utils/interface';
    import tinymce from '@/components/tinymce'
    export default {
        data() {
            return {
                goodsName: '',
                platformTypeCode: '',
                platformTypeOptions: [],
                tableData: [],
                props: {
                    value: 'code',
                    label: 'label',
                    checkStrictly: true
                },
                current:1,
                total: 0,
                pageSize: 8,
                dialogVisible: false,
                editForm:{
                    seoKeyword:"",
                    seoDescription:"",
                },
                editRules: {
                    seoKeyword: [
                        {required: true, message: '请输入SEO关键词', trigger: 'blur'},
                        {min: 0, max: 50, message: '最多允许输入50个汉字', trigger: 'blur'}
                    ],
                    seoDescription: [
                        {required: true, message: '请输入SEO描述', trigger: 'blur'},
                        {min: 0, max: 70, message: '最多允许输入70个汉字', trigger: 'blur'}
                    ],
                }
            }
        },
        created() {
            this.platformTypetree();
            this.getList();
        },
        methods: {
            // 清除检索
            search(){
                this.current = 1;
                this.getList();
            },
            reset(){
                this.current = 1;
                this.platformTypeCode = '';
                this.goodsName = '';
                this.getList();
            },
            getList(){
                this.loading = true;
                let code='';
                let platformTypeCodeArr = this.platformTypeCode;
                if(platformTypeCodeArr.length>0){
                    code = platformTypeCodeArr[platformTypeCodeArr.length-1];
                }
                let params = {
                    name: this.goodsName,
                    platformTypeCode: code,
                    status: "SHELVE",
                    current:this.current,
                    pageSize:this.pageSize,
                };
                getGoodsAuditList(params).then((res)=>{
                    this.total = res.total;
                    this.tableData = res.list;
                    this.loading = false
                });
            },
            editSeoInfo(uuid){
                getGoodsInfo(uuid).then((res)=>{
                    if(res.success) {
                        this.editForm = res.data;
                        this.dialogVisible = true;
                    }
                });
            },
            submitForm(){
                this.$refs.editForm.validate((valid) => {
                    if(valid){
                        updateGoodsSeoInfo(this.editForm).then((res)=>{
                            if(res.success) {
                                this.$message.success("编辑成功");
                                this.dialogVisible = false;
                                this.getList();
                            }
                        });
                    }
                });
            },
            open(uuid, status) {
                let content = '';
                if (status === 'STOCK') {
                    content = '下架'
                }
                if (status === 'SHELVE') {
                    content = '上架'
                }
                if (status === 'REVIEW') {
                    content = '提交'
                }
                this.$confirm('是否确定' + content + '?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        uuid: uuid,
                        status: status
                    };
                    updateGoodsInfoStatus(params).then((res) => {
                        if (res.success) {
                            if(res.message == 'REVIEW'){
                                this.$message.success('已提交审核，平台审核通过后自动上架');
                            }else{
                                this.$message.success(content+"成功");
                            }
                            this.getList();
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消' + content
                    });
                });
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getList()
            },
            platformTypetree() {
                let params = {
                    grade: "3",
                    type: 'PLATFORM'
                }
                typetree(params).then((res) => {
                    this.platformTypeOptions = res;
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .contentBox {
        width: 97%;
        background-color: white;
        margin: auto;
        padding: 20px;
        box-sizing: border-box;

        .goodsTop {
            .searchTop {
                display: flex;
                margin-bottom: 22px;

                .searchItem {
                    display: flex;
                    align-items: center;
                    margin-right: 30px;

                    .name {
                        min-width: 100px;
                    }
                }
            }

            .searchBottom {
                display: flex;
                margin-bottom: 22px;

                .searchItem {
                    display: flex;
                    align-items: center;
                    margin-right: 30px;

                    .name {
                        min-width: 100px;
                    }
                }
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;
                }
            }

            /deep/ .el-range-editor {
                width: 500px;

                /deep/ .el-range-input {
                    width: 242px;
                    height: 32px;
                    min-height: 32px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                }

                /deep/ .el-range__icon,
                /deep/ .el-range-separator,
                /deep/ .el-range__close-icon {
                    line-height: 29px;
                }

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;

                    /deep/ .el-range-input {
                        background-color: #fff;
                    }
                }
            }

            .searchBtn {
                width: 82px;
                background-color: #3d7fff;
                border: none;
                color: white;
                font-size: 14px;
                border-radius: 15px;
            }

            .resetBtn {
                color: #000000;
            }
        }

        .goodsListTable {

            .tableContent {
                min-height: 600px;

                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }

                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }

                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }
                }
            }

            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }

    }
    .dialogBox {
        .details {
            .detailsItem {
                padding-bottom: 20px;
                h3 {
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    // border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .itemContent {
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;

                    // padding: 0 30px;
                    .one-row {
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name {
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                        }
                    }
                    /deep/ .detailImg p img{
                        width: 100%!important;
                    }
                    .two-rows{
                        width: 100%;
                        margin-bottom: 22px;
                        // display: flex;
                        //   align-items: center;
                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name {
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                            img {
                                width: 216px;
                            }
                        }
                    }
                    .two-row {
                        width: 100%;
                        margin-bottom: 22px;
                        display: flex;
                        align-items: center;
                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name {
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                            img {
                                width: 216px;
                            }
                        }
                    }
                    .salesSpecifications{
                        display: block;
                        .tableContent{
                            padding: 15px 0;
                            .tableHeader{
                                display: flex;
                                justify-content: space-around;
                                line-height: 40px;
                                background: #f2f5fc;
                            }
                            .tableItem{
                                display: flex;
                                justify-content: space-around;
                                align-items: center;
                                padding: 15px 0;
                                img{
                                    width: 160px;
                                    height: 110px;
                                }
                            }
                            .name{
                                width: 20%;
                                min-width: 20%;
                                text-align: center;
                            }
                            .img{
                                width: 40%;
                                min-width: 40%;
                                text-align: center;
                            }
                        }
                    }
                    .commodityImages{
                        display: block;
                        .imagesContent{
                            padding: 15px 0;
                            display: flex;
                            flex-wrap: wrap;
                            .imgItem{
                                margin-bottom: 10px;
                                width: 25%;
                                text-align: center;
                            }
                            img{
                                width: 160px;
                                height: 110px;
                            }
                        }
                    }
                    .commodityVideo{
                        display: block;
                        .videosContent{
                            padding: 15px 0;
                            display: flex;
                            flex-wrap: wrap;
                            .videoItem{
                                margin-bottom: 10px;
                                width: 50%;
                                text-align: center;
                            }
                        }
                        video{
                            width: 350px;
                            height: 200px;
                        }
                    }
                }
                .itemPictureContent {
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    justify-content: space-between;
                    .one-row {
                        width: 30%;
                        margin-bottom: 22px;
                        img {
                            width: 100%;
                            height: 138px;
                            border: 1px solid #ddd;
                        }
                        .name {
                            text-align: center;
                            padding-top: 10px;
                            font-size: 14px;
                            display: flex;
                            .label {
                                min-width: 80px;
                            }
                        }
                    }
                }
            }
        }
        .audit {
            padding-bottom: 20px;
            h3 {
                font-weight: 700;
                font-size: 16px;
                color: #000;
                margin-top: 0;
                letter-spacing: 1px;
                // border-bottom: 1px solid #ddd;
                padding-bottom: 15px;
            }
            .auditContent {
                // padding: 0 30px;
            }
            .cause {
                display: flex;
                margin-top: 20px;
                .causeTitle {
                    min-width: 80px;
                    color: #3a8ee6;
                }
                .causeContent {
                    color: #000;
                }
            }
            .auditEnter {
                text-align: center;
                padding-top: 20px;
                button {
                    width: 120px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/commodityManagement/shop/shelveGoodsList.vue